module.exports = __webpack_public_path__ + "assets/img/teacher (19).88d06887.png";